const baseUrl = process.env.REACT_APP_BASE_URL;
const token = process.env.REACT_APP_TOKEN;

if (!baseUrl) {
  throw new Error("API Url is not provided.");
}
const API_ROUTE = `${baseUrl}`;
const API_TOKEN = token;
const data = { API_ROUTE, API_TOKEN };
export default data;
